<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  customers: number
  products: number
  activeInstances: number
  usageEventsThisMonth: number
}>()

const formatNumber = new Intl.NumberFormat('pl').format

const stats = computed(() => [
  {
    title: 'Customers Count',
    icon: 'i-lucide-user-round',
    value: formatNumber(props.customers),
  },
  {
    title: 'Products Count',
    icon: 'i-lucide-box',
    value: formatNumber(props.products),
  },
  {
    title: 'Active Instances',
    icon: 'i-lucide-satellite-dish',
    value: formatNumber(props.activeInstances),
  },
  {
    title: 'Usage Events This Month',
    icon: 'i-lucide-activity',
    value: formatNumber(props.usageEventsThisMonth),
  },
])
</script>

<template>
  <UPageGrid class="gap-4 sm:gap-6 lg:grid-cols-4 lg:gap-px">
    <UPageCard
      v-for="(stat, index) in stats"
      :key="index"
      :icon="stat.icon"
      :title="stat.title"
      variant="subtle"
      :ui="{
        container: 'gap-y-1.5',
        wrapper: 'items-start',
        leading:
          'p-2.5 rounded-full bg-primary/10 ring ring-inset ring-primary/25',
        title: 'font-normal text-muted text-xs uppercase',
      }"
      class="first:rounded-l-lg last:rounded-r-lg hover:z-1 lg:rounded-none"
    >
      <div class="flex items-center gap-2">
        <span class="text-highlighted text-2xl font-semibold">
          {{ stat.value }}
        </span>
      </div>
    </UPageCard>
  </UPageGrid>
</template>
